export default __webpack_public_path__ + "static/media/in.cfdacec3.svg";